import PropTypes from 'prop-types';

import './index.less';

const selectIconType = (type) => {
  const typeToIcon = {
    error: 'fa-exclamation-circle',
    warning: 'fa-exclamation-triangle',
    info: 'fa-info-circle',
  };

  return typeToIcon[type];
};

/**
 * Inspired by https://design.nav.no/components/alertstripe/
 * */
const NotificationCard = ({ title, type, children }) => <div className={`notificationcard is-${type}`}>
  <i className={`fas ${selectIconType(type)} notificationcard-icon`}/>

  <section className="notificationcard-body">
    <h3 className="notificationcard-header">{title}</h3>

    <div className="notificationcard-content">{children}</div>
  </section>
</div>;

NotificationCard.propTypes = {
  title: PropTypes.any.isRequired,
  type: PropTypes.oneOf(['info', 'warning', 'error']).isRequired,
  children: PropTypes.any.isRequired,
};

export default NotificationCard;
